/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LpisKultura } from './lpisKultura.model';
import { BarterResultPk } from './barterResultPk.model';


export interface BarterResult { 
    barterResultPk?: BarterResultPk;
    concernedAcreage?: number;
    counterpartyAcreage?: number;
    lpisKultura?: LpisKultura;
}

